// extracted by mini-css-extract-plugin
export default {"button":"Error_button__VWHmT","lines":"Error_lines__yQmBX"};